import config from '../config/config';

export const airDropAddress =
  process.env.REACT_APP_NODE_ENV_LOCAL == 'production' ? config.airDropAddress.polygonMainnet : config.airDropAddress.polygonMumbai;

export const ChainId = process.env.REACT_APP_NODE_ENV_LOCAL == 'production' ? config.chain.polygonMainnet : config.chain.polygonMumbai;

